
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgServiceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M65.793 97.398c5.655-.843 11.384-2.817 15.234-6.67 4.784-4.784 8.51-12.893 8.51-20.146V45.901c0-7.253-3.726-14.609-8.51-19.39C76.245 21.727 68.889 18 61.637 18h-3.62c-7.252 0-14.608 3.727-19.39 8.51-4.784 4.782-8.51 12.138-8.51 19.391V70.58M30 71c-6.707-.522-12-6.59-12-13.999 0-7.41 5.293-13.478 12-14.001M90 71c6.707-.522 12-6.59 12-14s-5.293-13.477-12-14",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeMiterlimit: 22.926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M60 89a8 8 0 1 1 0 16 8 8 0 0 1 0-16Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n  <path d=\"M65.7928 97.3985C71.4483 96.5547 77.1767 94.5808 81.0266 90.7284C85.8107 85.9443 89.5375 77.8352 89.5375 70.5824V45.901C89.5375 38.6482 85.8107 31.2925 81.0266 26.5109C76.245 21.7268 68.8893 18 61.6365 18H58.0177C50.7649 18 43.4092 21.7268 38.6276 26.5109C33.8435 31.2925 30.1167 38.6482 30.1167 45.901V70.5799\" stroke=\"#000000\" stroke-width=\"4.4\" stroke-miterlimit=\"22.9256\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M30 71C23.2926 70.4775 18 64.4094 18 57.0012C18 49.5906 23.2926 43.5225 30 43\" stroke=\"#000000\" stroke-width=\"4.4\" stroke-miterlimit=\"22.9256\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M90 71C96.7074 70.4775 102 64.41 102 57C102 49.59 96.7074 43.5225 90 43\" stroke=\"#000000\" stroke-width=\"4.4\" stroke-miterlimit=\"22.9256\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M60 89C64.4183 89 68 92.5817 68 97C68 101.418 64.4183 105 60 105C55.5817 105 52 101.418 52 97C52 92.5817 55.5817 89 60 89Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/service-icon.3c19319100aca9fe5b54f293fd7825a3.svg"),
        {
          React: SvgServiceIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      